import { useCallback, useEffect, useState } from 'react'
import { getRoutes } from '../../router'
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Typography, Badge } from '@material-ui/core'
import { getDashboardStatistics } from '../../api/statistics.service'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(() => ({
  shortcutItem: {
    height: '11rem',
    backgroundColor: 'white',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(255, 23, 68, 0.04)',
      textDecoration: 'none'
    }
  }
}))

export default function ShortcutButtons(props) {
  const classes = useStyles()
  const providerSelected = useSelector((state) => state.provider)

  const permissions = providerSelected.providerPermissions || {}
  const routesToHide = [
    ...(!providerSelected.urlCatalog ? ['/general-catalog'] : []),
    ...(!permissions.showMyReports ? ['/reports'] : []),
    ...(!permissions.showIrpIncidences ? ['/irp-incidences'] : []),
    ...(!permissions.showNonConformity ? ['/non-conformity-incidences'] : []),
    ...(!permissions.showMyOrders ? ['/incidences'] : [])
  ]
  const routes = getRoutes(routesToHide)

  const [statistics, setStatistics] = useState({})

  const getStatistics = useCallback(() => {
    getDashboardStatistics(providerSelected.id).then(({ data }) => {
      setStatistics(data)
    })
  }, [providerSelected.id])

  useEffect(() => {
    getStatistics()
  }, [getStatistics])

  const getStatisticValue = (path) => {
    switch (path) {
      case '/modified-products':
        return statistics.productModificationsInProgress
      case '/orders':
        return statistics.newOrders
      case '/incidences':
        return statistics.pendingOrderIncidences
      default:
        return undefined
    }
  }

  const shortcuts = routes
    .map((route) => {
      if (route.path && !route.children && route.isShortcut) {
        return route
      } else {
        if (route.children) {
          return [
            ...route.children.map((routeChildren) => {
              if (routeChildren.path && routeChildren.isShortcut) {
                routeChildren.count = getStatisticValue(routeChildren.path)
                return routeChildren
              }
              return null
            })
          ]
        }
      }
      return null
    })
    .flat(Infinity)
    .filter((route) => route !== null)
    .concat(props.extraShortcuts)

  return (
    <Grid container spacing={0} direction="row" alignItems="center">
      {shortcuts.map((route, index) => (
        <Grid key={`shortcuts-${index}`} item xs={6} md={4}>
          {route.path ? (
            <Link
              to={route.path}
              className={
                classes.shortcutItem + ' text-center border border-primary rounded m-2 d-flex'
              }
            >
              <div className="m-auto" style={{ width: '-webkit-fill-available' }}>
                {route.count ? (
                  <Badge badgeContent={route.count} color="secondary">
                    <svg width="70" height="70">
                      {route.icon}
                    </svg>
                  </Badge>
                ) : (
                  <svg width="70" height="70">
                    {route.icon}
                  </svg>
                )}
                <Typography variant="h6" color="secondary">
                  {route.shortcutTitle}
                </Typography>
              </div>
            </Link>
          ) : (
            <div
              className={
                classes.shortcutItem + ' text-center border border-primary rounded m-2 d-flex'
              }
              onClick={route.action}
            >
              <div className="m-auto" style={{ width: '-webkit-fill-available' }}>
                {route.count ? (
                  <Badge badgeContent={route.count} color="secondary">
                    <svg width="70" height="70">
                      {route.icon}
                    </svg>
                  </Badge>
                ) : (
                  <svg width="70" height="70">
                    {route.icon}
                  </svg>
                )}
                <Typography variant="h6" color="secondary">
                  {route.shortcutTitle}
                </Typography>
              </div>
            </div>
          )}
        </Grid>
      ))}
    </Grid>
  )
}
